import { Icon } from '../icon/icon'
import styles from './validatable.module.css'

type Props = {
    validations?: string[]
    type?: 'warning' | 'error'
    left?: boolean
    expanded?: boolean
    className?: string
    children?: JSX.Element
}

export const Validatable = (props: Props) => {
    const { validations = [], type = 'error', left = false, expanded, className, children } = props

    const typeClassName = type === 'warning' ? styles.warning : ''
    const sideClassName = left ? styles.left : styles.right
    const expandedClassName = expanded ? styles.expanded : ''
    
    return (
        <div className={styles.container}>
            {children}
            {validations.length > 0 && (
                <div className={`${styles.validationContainer} ${typeClassName} ${sideClassName} ${expandedClassName} ${className}`}>
                    {validations.map((validation, index) => {
                        return (
                            <div key={index}>
                                <Icon
                                    icon='info-circle'
                                    color='quaternary'
                                    className={styles.leftMargin}
                                    small
                                    rightMargin
                                />
                                {validation}
                            </div>
                        )
                    })}
                </div>
            )}
        </div>
    )
}
